import { WebSocketService } from '../services/websocket.service';
import { environment } from '@env/environment';

/**
 * Initializer pour connecter automatiquement WebSocket
 */
export function initializeWebSocketFactory(
  webSocketService: WebSocketService
) {
  return () => {
    if (!environment.production) {
      console.log('🔌 Initialisation WebSocket...');
    }

    // Connecter WebSocket après délai pour laisser l'app se charger
    setTimeout(() => {
      webSocketService.connect().subscribe({
        next: (connected) => {
          if (connected) {
            if (!environment.production) {
              console.log('✅ WebSocket connecté via initializer');
            }
          }
        },
        error: (error) => {
          console.warn('⚠️ WebSocket initializer erreur:', error);
        }
      });
    }, 2000); // Délai de 2 secondes

    // Retourner une Promise résolue immédiatement pour ne pas bloquer le démarrage
    return Promise.resolve();
  };
}